export interface TensileRequirementByGrade {
	TensileRequirementsByGradeId: number | null;
	TensileRequirementVersionId: number | null;
	Rev: number | null;
	EffectiveDate: string | null;
	Comments: string | null;
	GradeId: number | null;
	GradeName: string | null;
	SWV: number | null;
	Yield: string | null;
	Tensile: string | null;
	Elongation: string | null;
	PercentRA: string | null;
	Impact: string | null;
	TestsPerHeat: string | null;
	YieldMin: number | null;
	YieldMax: number | null;
	TensileMin: number | null;
	TensileMax: number | null;
	Unit: string | null;
	ElongationPercentMin: number | null;
	ElongationLength: string | null;
	PercentRAMin: number | null;
	PercentRAMax: number | null;
	ImpactMin: number | null;
	ImpactMax: number | null;
	IsActive: boolean;
}

export const TENSILE_REQUIREMENT_INITIAL_VALUES: TensileRequirementByGrade = {
	TensileRequirementsByGradeId: null,
	TensileRequirementVersionId: null,
	Rev: null,
	EffectiveDate: null,
	Comments: null,
	GradeId: null,
	GradeName: null,
	SWV: null,
	Yield: null,
	Tensile: null,
	Elongation: null,
	PercentRA: null,
	Impact: null,
	TestsPerHeat: null,
	YieldMin: null,
	YieldMax: null,
	TensileMin: null,
	TensileMax: null,
	Unit: null,
	ElongationPercentMin: null,
	ElongationLength: null,
	PercentRAMin: null,
	PercentRAMax: null,
	ImpactMin: null,
	ImpactMax: null,
	IsActive: true,
};
